import { useState, useEffect } from 'react';
import { getOrgSlug } from '../utils/subdomain';

/**
 * Set the page favicon to a given image URL.
 * Falls back to /favicon.ico if no URL provided.
 */
export function setFavicon(url) {
  const link = document.querySelector("link[rel~='icon']") || (() => {
    const el = document.createElement('link');
    el.rel = 'icon';
    document.head.appendChild(el);
    return el;
  })();
  link.href = url || '/favicon.ico';
}

/**
 * Fetches org branding from the API when on an org subdomain.
 * Returns { branding, isLoading, orgSlug }.
 */
export function useBranding() {
  const [branding, setBranding] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const orgSlug = getOrgSlug();

  useEffect(() => {
    if (!orgSlug) return;

    setIsLoading(true);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

    fetch(`${API_BASE_URL}/api/users/org-branding/${orgSlug}/`)
      .then((res) => {
        if (!res.ok) throw new Error('Not found');
        return res.json();
      })
      .then((data) => {
        setBranding(data);
        // Use org's small logo as favicon when available
        if (data?.logo_small) setFavicon(data.logo_small);
      })
      .catch(() => setBranding(null))
      .finally(() => setIsLoading(false));
  }, [orgSlug]);

  return { branding, isLoading, orgSlug };
}
